module.exports = __webpack_public_path__ + "img/pinestone-logo-en.adbd82d4.png";